<div class="content" [ngClass]="{ loading: loading }" *ngIf="responseFound">
  <mat-progress-spinner
    *ngIf="loading"
    class="example-margin"
    [color]="'primary'"
    [mode]="'indeterminate'"
  ></mat-progress-spinner>

  <div class="dataset-container scrollbar-custom-scroll-style" *ngIf="!loading">
    <div class="heading">
      Dataset Details
      <img
        class="close-icon"
        src="..\..\..\..\assets\icons\svg\x-circle.svg"
        alt="close"
        height="30"
        width="30"
        (click)="closeDialog()"
        (keydown)="closeDialog()"
      />
    </div>
    <div>
      <ng-container
        *ngIf="datasetDetails?.metadata?.length > 4; else tabSwitch"
      >
        <mat-form-field floatLabel="always" class="filter-mat-select-catalogue">
          <mat-select
            #viewSelect
            panelClass="testClass1"
            class="mater-selection"
            name="filter"
            id="filter"
            [ngClass]="{
              'rotate-down-arrow-icon': viewSelect.panelOpen
            }"
            placeholder="Select Table"
          >
            <ng-scrollbar
              appearance="compact"
              [autoHeightDisabled]="true"
              [autoWidthDisabled]="true"
              class="hgt-165px scrollbar-custom-scroll-style"
            >
              <mat-option
                *ngFor="let table of datasetDetails?.metadata; let i = index"
                value="table.TableName"
                (click)="onTableHeadingClick(i)"
                (keydown)="onTableHeadingClick(i)"
                >{{ getTableName(table.sqltablename) }}</mat-option
              >
            </ng-scrollbar>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-template #tabSwitch>
        <mat-button-toggle-group class="button-margin p-1 pe-auto">
          <mat-button-toggle
            *ngFor="let table of datasetDetails?.metadata; let i = index"
            (click)="onTableHeadingClick(i)"
            (keydown)="onTableHeadingClick(i)"
            value="table.TableName"
            [checked]="i == table_index"
          >
            {{ getTableName(table.sqltablename) }}</mat-button-toggle
          >
        </mat-button-toggle-group>
      </ng-template>
    </div>

    <div class="button-group">
      <button
        type="submit"
        class="display-button mb-3"
        (click)="onViewColumn()"
      >
        Column Description
      </button>
    </div>
    <div class="title">Table Preview</div>

    <div class="table">
      <ng-container *ngIf="currentTableDetails?.data != null; else noTable">
        <table class="table-layout">
          <thead>
            <tr class="row-layout">
              <th class="table-heading" *ngFor="let column of head">
                <div class="head-width">{{ column }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-layout" *ngFor="let row of currentTableDetails.data">
              <td class="table-content" *ngFor="let column of head">
                <div class="content-width">{{ row[column] }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #noTable>
        <div class="no-data">No data available for this table.</div>
      </ng-template>
    </div>
    <div>
      <div class="head">Uploaded Files:</div>
      <div class="type">
        Data File:
        <ng-container *ngIf="dataFiles && dataFiles.length > 0; else noFile">
          <span
            *ngFor="let file of dataFiles; let i = index"
            class="hyperlink-text me-2"
            (click)="downloadFile(file)"
            (keydown)="downloadFile(file)"
            >{{ file.filename }}{{ i == dataFiles.length - 1 ? "" : "," }}</span
          >
        </ng-container>
      </div>
      <div class="type">
        Metadata File:
        <ng-container *ngIf="metaFiles && metaFiles.length > 0; else noFile">
          <span
            *ngFor="let file of metaFiles; let i = index"
            class="hyperlink-text me-2"
            (click)="downloadFile(file)"
            (keydown)="downloadFile(file)"
            >{{ file.filename }}{{ i == metaFiles.length - 1 ? "" : "," }}</span
          >
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #noFile>
  <span class="no-file">No files attached</span>
</ng-template>

<div class="not-found" *ngIf="responseFound == false">
  <div class="title">404</div>
  <div class="content-not-found">OOPS! Dataset details not Found.</div>
</div>
